// WikiAdmin.jsx — admin console shell: Interactions / Training segmented toggle.
import React, { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import WikiInteractions from './WikiInteractions';
import WikiTraining from './WikiTraining';
import WikiAccess from './WikiAccess';

export default function WikiAdmin({ onOpenDoc }) {
    const [tab, setTab] = useState('interactions');
    return (
        <div className="h-full flex flex-col min-w-0">
            <div className="h-14 px-5 flex items-center gap-3 border-b border-stone-200 bg-white">
                <div className="w-8 h-8 rounded-lg bg-stone-900 text-white flex items-center justify-center"><ShieldCheck className="w-4 h-4" /></div>
                <div className="flex-1"><div className="text-[14px] wiki-display font-bold text-stone-900">Wiki AI — Admin</div><div className="text-[11px] text-stone-500">Monitor every agent interaction and train answers</div></div>
                <div className="flex gap-1 p-0.5 bg-stone-100 rounded-lg">
                    {[['interactions', 'Interactions'], ['training', 'Training'], ['access', 'Access']].map(([k, l]) => (
                        <button key={k} onClick={() => setTab(k)} className={`px-3 py-1.5 rounded-md text-[12px] font-semibold ${tab === k ? 'bg-white wiki-shadow-soft text-stone-900' : 'text-stone-500 hover:text-stone-900'}`}>{l}</button>
                    ))}
                </div>
            </div>
            <div className="flex-1 overflow-auto bg-stone-50">
                {tab === 'interactions' ? <WikiInteractions onOpenDoc={onOpenDoc} /> : tab === 'training' ? <WikiTraining /> : <WikiAccess />}
            </div>
        </div>
    );
}
